// gloss
export const isRecord = <T = unknown>(value: unknown): value is Record<string, T> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);
